import React, { useMemo } from "react";

export const Button = ({ variant = "primary", className, children, ..._props }) => {
    const baseClass = `btn p-2 rounded-md w-max`
    const variantClass = useMemo(() => {
        switch(variant){
            case "primary": return "bg-primary text-neutral hover:bg-primary"
            case "secondary": return "bg-secondary text-neutral hover:bg-secondary"
            case "accent": return "bg-accent text-dark-text hover:bg-accent"
        }
    }, [variant])

    return (
        <div className={`${baseClass} ${variantClass} ${className}`} {..._props}>
            {children}
        </div>
    )
}